<template>
<div class="row">
    <div class="col-12 mb-3">
        <div v-if="user.id" class="row">
            <div class="col-6 align-self-end">
                
            </div>
            <div class="col-6 text-end">
                <a @click.prevent="changeView(true)" href="#" title="List View" class="btn-item-view text-secondary"><i class="fa-light fa-table-rows"></i></a>
                <a @click.prevent="changeView(false)" href="#" title="Thumbs View" class="btn-item-view text-secondary ms-3"><i class="fa-light fa-grid-2"></i></a>
            </div>
        </div>
    </div>
    <div v-if="listView" class="col-12">
        <div v-if="enhanced || user.sub" id="pin-list-tools" class="col-12 rounded-top bg-light px-3 py-2">
            <div class="row">
                <div class="col-12 col-md-8 col-lg mb-4 text-center text-sm-start">
                    <h4 class="mb-3"><span class="text-muted">Batch Edit:</span> <strong>{{ totalSelected }} selected pins</strong></h4>

                    <div class="btn-group" data-bs-toggle="tooltip" data-bs-placement="top" title="Toggles ISO on selected pins">
                        <button class="btn btn-outline-iso dropdown-toggle" :class="{disabled: !anySelected}" type="button" id="batch-iso-button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            ISO
                        </button>
                        <div class="dropdown-menu" aria-labelledby="batch-iso-button">
                            <a @click.prevent="addCollection('iso')" class="dropdown-item text-iso" href="#"><i class="fa-solid fa-plus"></i> Set as ISO</a>
                            <a @click.prevent="removeCollection('iso')" class="dropdown-item" href="#"><i class="fa-solid fa-minus"></i> Clear ISO</a>
                        </div>
                    </div>

                    <div class="btn-group mx-2" data-bs-toggle="tooltip" data-bs-placement="top" title="Toggles OWN on selected pins">
                        <button class="btn btn-outline-own dropdown-toggle" :class="{disabled: !anySelected}" type="button" id="batch-own-button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            OWN
                        </button>
                        <div class="dropdown-menu" aria-labelledby="batch-own-button">
                            <a @click.prevent="addCollection('own')" class="dropdown-item text-own" href="#"><i class="fa-solid fa-plus"></i> Set as OWN</a>
                            <a @click.prevent="removeCollection('own')" class="dropdown-item" href="#"><i class="fa-solid fa-minus"></i> Clear OWN</a>
                        </div>
                    </div>

                    <div class="btn-group" data-bs-toggle="tooltip" data-bs-placement="top" title="Toggles TRADER on selected pins">
                        <button class="btn btn-outline-trader dropdown-toggle" :class="{disabled: !anySelected}" type="button" id="batch-trader-button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            TRADER
                        </button>
                        <div class="dropdown-menu" aria-labelledby="batch-trader-button">
                            <a @click.prevent="addCollection('trader')" class="dropdown-item text-trader" href="#"><i class="fa-solid fa-plus"></i> Set as TRADER</a>
                            <a @click.prevent="removeCollection('trader')" class="dropdown-item" href="#"><i class="fa-solid fa-minus"></i> Clear TRADER</a>
                        </div>
                    </div>

                    <!-- <button v-if="user.isCollection && user.collection !== 'sample'" @click="exportCollection()" class="btn btn-outline-dark ms-4 mt-4 mt-sm-0" :class="{disabled: !anySelected}" type="button"  data-bs-toggle="tooltip" data-bs-placement="top" title="Download Excel compatible CSV of selected pins."><i class="fa-regular fa-cloud-arrow-down"></i> Export Pins</button> -->
                </div>

                <div v-if="tags.length && enhanced" class="col-12 col-md text-center">
                    <hr class="d-block d-sm-none">
                    <button type="button" class="btn btn-sm btn-link text-dark me-2 mb-3" :class="{disabled: !anySelected}" data-bs-toggle="modal" data-bs-target="#add-tags">Add Tags</button>
                    <button v-if="this.tags.filter(tag => tag.checked).length" @click="addTags" type="button" class="btn btn-sm btn-outline-primary mb-3">Apply Tags</button>
                    <tag-selector :all-tags="tags" :initial="[]" :limit="0"></tag-selector>
                </div>

                <!-- <div v-if="enhanced && tradeBoards.length" class="col-12 col-md text-center">
                    <div class="dropdown">
                        <button class="btn btn-sm dropdown-toggle btn-outline-dark" :class="{disabled: !anySelected}" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Add to Board
                        </button>
                        <div class="dropdown-menu" aria-labelledby="add-to-board-button">
                            <template v-for="parent in tradeBoards.filter(b => b.is_parent)">
                                <h6 :key="parent.id" class="dropdown-header">{{ parent.name }}</h6>
                                <a v-for="board in tradeBoards.filter(b => b.parent_id === parent.id)" :key="board.id" @click.prevent="addTradeBoard(board.id)" class="dropdown-item" href="#">{{ board.name }}</a>
                                <div class="dropdown-divider"></div>
                            </template>
                            <template v-for="board in tradeBoards.filter(b => !b.is_mystery && !b.is_parent && !b.parent_id)">
                                <a @click.prevent="addTradeBoard(board.id)" :key="board.id" class="dropdown-item" href="#">{{ board.name }}</a>
                                <div class="dropdown-divider"></div>
                            </template>
                            <template v-if="tradeBoards.find(b => b.is_mystery)">
                                <h6 class="dropdown-header">Mystery Boards</h6>
                                <a v-for="board in tradeBoards.filter(b => b.is_mystery)" :key="board.id" @click.prevent="addTradeBoard(board.id)" class="dropdown-item mystery-board-item" href="#">{{ board.name }}</a>
                            </template>
                        </div>
                    </div>
                </div> -->

            </div>

        </div>

        <table class="pin-list table bg-light table-bordered table-striped mb-5">
            <thead>
            <tr class="text-center">
                <th v-if="enhanced || user.sub" scope="col" class="pin-select align-middle">
                    <label class="" for="select-shown-pins"></label>
                    <input type="checkbox" id="select-shown-pins" v-model="selectShown">
                </th>
                <th scope="col" class="pin-select align-middle">
                    <span v-if="(enhanced || user.sub) && selectShown && total > pins.length && allPinIds.length">
                        <label class="" for="select-all-pins"></label>
                        <input class="" type="checkbox" id="select-all-pins" v-model="selectAll"> <span v-if="total < max">All</span> {{ Math.min(total, max) }}
                        <span v-if="Math.min(total, max) === max" class="text-muted small"> (max)</span>
                    </span>
                </th>
                <th scope="col">Pin</th>
                <th scope="col" class="d-none d-md-table-cell">Set / Series</th>
                <th scope="col" class="d-none d-md-table-cell">Year</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="pin in pins" :key="pin.id" class="">
                <td v-if="enhanced || user.sub" class="align-middle text-center pin-select">
                    <label class="" :for="'pin-' + pin.id"></label>
                    <input type="checkbox" class="select-pin" :id="'pin-' + pin.id" v-model="pin.selected">
                </td>
                <td class="text-center">
                    <a v-if="pin.cover" :href="'/pins/' + pin.id + '/' + pin.slug">
                        <picture>
                            <source :srcset="pin.cover.srcset.webp" type="image/webp">
                            <source :srcset="pin.cover.srcset.jpg" type="image/jpeg">
                            <img :src="pin.cover.srcset.jpg" class="img-fluid m-auto" :alt="pin.name">
                        </picture></a>
                </td>
                <td>
                    <a :href="'/pins/' + pin.id + '/' + pin.slug" class="clearfix">
                        <span v-if="pin.series_id">{{ pin.series.name }} - </span>
                        {{ pin.name }}
                        <span v-if="pin.origin_id"> - {{ origin.find(o => o.id === pin.origin_id)['code'] }}</span>
                    </a>
                    <i v-if="pin.grails && pin.grails.length" class="fa-regular fa-crown text-grail fa-xs" title="Grail"></i>

                    <h5 v-if="pin.rarity" class="rarity-container">
                        <span class="badge rarity" :class="pin.rarity.slug">{{ pin.rarity.slug }}</span>
                    </h5>

                    <div v-if="user.id" class="d-none d-sm-block mt-3 pin-list-controls float-start me-3">
                        <pin-collection-controls :let-manage="user.manage" :url="'/pins/' + pin.id" :pinsearchof="pin.wanted" :collection="pin.grails" :pinventory="pin.pinventory" :pin="pin.id"></pin-collection-controls>
                    </div>
                </td>
                <td class="d-none d-md-table-cell">
                    <div v-if="pin.set" class="mb-2">
                        <a v-if="pin.series" :href="'/series/' + pin.series.slug + '/' + pin.set.slug" class="small">{{ pin.set.name }}</a>
                        <a v-else :href="'/set/' + pin.set_id + '/' + pin.set.slug" class="small">{{ pin.set.name }}</a>
                    </div>
                    <a v-if="pin.series_id" :href="'/series/' + pin.series.slug" class="small">{{ pin.series.name }}</a>
                </td>
                <td class="d-none d-md-table-cell">
                    {{ releaseDate(pin.id) }}
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <div v-else class="col-md-12" :class="{'coll-thumbs': collectionView}">
        <div class="row">
        <template v-for="(pin, index) in pins">
            <div v-if="index === (collectionView ? (pins.length > 30 ? 30 : 0) : (pins.length > 12 ? 12 : 0))" class="col-12">
                <pins-ad :li="!!user.id"></pins-ad>
            </div>

            <div class="pin-card-col" :class="[index > 2 ? 'd-lg-inline-block' : 'd-md-inline-block']">
                <div class="pin-card" :class="{ grail: pin.grails && pin.grails.length }">
                    <div class="position-relative card-top-wrapper">
                        <img class="card-top w-100 position-relative" :src="'/img/pin-card-top.png'">
                        <img class="card-top-over w-100" :src="'/img/pin-card-top.png'">
                        <div class="card-top-container">
                            <div class="locked d-flex justify-content-center">
                                <i v-if="pin.is_locked" class="fa-regular fa-lock px-1"></i>
                                <i v-if="pin.flag_count && pin.flag_count > 0" class="px-1 text-warning fa-regular fa-triangle-exclamation"></i>
                            </div>
                            <div class="thumb-grail"><i v-if="pin.grails && pin.grails.length" class="fa-regular fa-crown text-grail" title="Grail"></i></div>
                            <div class="copy-id"><span @click="copyId(pin.id, $event)" class="copy-id-link"><i class="fa-solid fa-barcode text-muted"></i></span><span class="id-copied"><i class="fa-regular fa-copy"></i> {{ pin.id }}</span></div>
                        </div>
                    </div>
                    <div class="card">
                        <h5 v-if="pin.rarity" class="rarity-container position-absolute">
                            <button data-bs-toggle="modal" data-bs-target="#rarity-modal"><span class="badge rarity" :class="pin.rarity.slug">{{ pin.rarity.slug }}</span></button>
                        </h5>
                        <div class="card-image d-flex align-items-center">
                            <a v-if="pin.cover" :href="'/pins/' + pin.id + '/' + pin.slug">
                                <picture>
                                    <source :srcset="pin.cover.srcset.webp" type="image/webp">
                                    <source :srcset="pin.cover.srcset.jpg" type="image/jpeg">
                                    <img :src="pin.cover.srcset.jpg" class="card-img-top" :alt="pin.name">
                                </picture></a>
                        </div>

                        <div class="card-body">
                            <h5 class="card-title">
                                <a :href="'/pins/' + pin.id + '/' + pin.slug">
                                    <!-- <span v-if="pin.series_id">{{ pin.series.name }} - </span> -->
                                    {{ pin.name }}
                                    <span v-if="pin.origin_id"> - {{ origin.find(o => o.id === pin.origin_id)['code'] }}</span>
                                </a>
                            </h5>

                            <pin-collection-controls v-if="user.id" :let-manage="user.manage" :url="'/pins/' + pin.id" :pinsearchof="pin.wanted" :collection="pin.grails" :pinventory="pin.pinventory" :pin="pin.id"></pin-collection-controls>
                            <collection-controls-guest v-else :is-list="true"></collection-controls-guest>
                        </div>

                        <div v-if="pin.set" class="card-footer card-set">
                            <strong class="footer-section-title">Set</strong>
                            <small v-if="pin.series" class="text-muted"><a :href="'/series/' + pin.series.slug + '/' + pin.set.slug">{{ pin.set.name }}</a></small>
                            <small v-else class="text-muted"><a :href="'/set/' + pin.set_id + '/' + pin.set.slug">{{ pin.set.name }}</a></small>
                        </div>

                        <div v-if="pin.series" class="card-footer card-series">
                            <strong class="footer-section-title">Series</strong>
                            <small class="text-muted"><a :href="'/series/' + pin.series.slug">{{ pin.series.name }}</a></small>
                        </div>

                        <div class="card-footer">
                            <div class="row">
                                <div class="col pin-book">
                                    <button v-if="user.id" @click="selectedPin = pin" type="button" class="btn btn-sm btn-outline-secondary" :data-pin="pin.id" data-bs-toggle="modal" data-bs-target="#my-pin-books"><i class="fa-solid fa-book fa-lg"></i><span class="ms-1 d-none d-xl-inline"> Pin Books</span></button>
                                </div>
                                <div class="col card-released text-end">
                                    <small class="text-muted"><span class="released-title d-none d-sm-inline">Released: </span>{{ releaseDate(pin.id) }}</small>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </template>

        </div>
    </div>

    <pin-book-controls v-if="user.id" :user="user" :enh="enhanced" :pin="selectedPin"></pin-book-controls>

</div>
</template>

<script>
import PinCollectionControls from "./PinCollectionControls.vue";
import CollectionControlsGuest from "./CollectionControlsGuest.vue";
import TagSelector from "./TagSelector.vue";
import PinsAd from "./PinsAd.vue";
import PinBookControls from "./PinBookControls.vue";

export default {
    name: "Pins",
    components: {
        PinBookControls,
        PinCollectionControls,
        CollectionControlsGuest,
        TagSelector,
        PinsAd
    },
    props: {
        pinData: Array,
        total: Number,
        origin: Array,
        allPinIds: {
            type: Array,
            default: () => ([])
        },
        user: {
            type: Object,
            default: () => ({id: null, sub: null, manage: 0, isCollection: false, boards: []})
        },
        tags: {
            type: Array,
            default: () => ([])
        },
        enhanced: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            pins: [],
            selectedPin: {},
            listView: false,
            collectionView: this.user && this.user.isCollection,
            selectShown: false,
            selectAll: false,
            tradeBoards: [],
            max: this.enhanced ? 10000 : 500,
            pinTools: null
        }
    },
    created() {
        //
    },
    mounted() {
        this.pins = this.pinData.filter(p => {
            p.selected = false;
            p.boards = this.user && this.user.boards ? JSON.parse(JSON.stringify(this.user.boards)) : [];
            return p;
        });

        this.listView = this.user.id && localStorage.pinListView && localStorage.pinListView === 'table';

        if (this.user && this.user.boards) {
            this.tradeBoards = this.user.boards;
        }

        window.addEventListener('load', () => {
            const tooltipTriggerList = [].slice.call(document.querySelectorAll('#pin-list-tools [data-bs-toggle="tooltip"]'))
            let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new bootstrap.Tooltip(tooltipTriggerEl)
            })

            // const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
            // let popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
            //     return new bootstrap.Popover(popoverTriggerEl, {
            //         container: 'body',
            //         placement: 'auto'
            //     })
            // })
        });
    },
    methods: {
        releaseDate (id) {
            let releasedAt = this.pins.find(p => p.id === id).released_at;
            if (releasedAt) {
                // releasedAt = new Date(releasedAt);
                // return releasedAt.getFullYear();
                return releasedAt.substr(0, 4);
            } else {
                return 'Unknown';
            }
        },

        changeView (listView) {
            if (this.listView !== listView) {
                this.listView = listView;
                localStorage.pinListView = listView ? 'table' : 'thumbs';
            }
        },

        addTags () {
            const pins = this.selectAll ? this.allPinIds : this.pins.filter(p => p.selected).map(p => p.id);
            const tags = this.tags.filter(t => t.checked).map(t => t.id);

            axios.post('/tags/pins', {
                pins: pins,
                tags: tags
            }).then(response => {
                if (response.status === 200) {

                }
            });
        },

        addTradeBoard (board) {
            const pins = this.pins.filter(p => p.selected);
            const ids = pins.map(p => p.pinventory_id);

            axios.post('/pin-trading/listings', {
                board: board,
                pinventory: ids
            }).then(response => {
                pins.forEach(p => {
                    let bIndex = p.boards.findIndex(b => b.id === board);
                    p.boards[bIndex].added = true;
                });
            });
        },

        addCollection (collection) {
            axios.post('/pin-collections/batch-add', {
                pins: this.selectAll ? this.allPinIds : this.pins.filter(p => p.selected).map(p => p.id),
                collection: collection
            }).then(response => {
                if (response.status === 200) {
                    this.pins.filter(p => p.selected).forEach(pin => {
                        let found = response.data.find(d => d.pin_id === pin.id);
                        if (found) {
                            if (collection === 'iso') {
                                pin.wanted = [found];
                            } else {
                                if (collection === 'own' || !pin.pinventory.length) {
                                    pin.pinventory = [found];
                                } else {
                                    pin.pinventory.find(pv => pv.id === found.id).is_trader = 1;
                                }
                            }
                        }
                    });
                }
            });
        },

        removeCollection (collection) {
            axios.post('/pin-collections/batch-remove', {
                pins: this.selectAll ? this.allPinIds : this.pins.filter(p => p.selected).map(p => p.id),
                collection: collection
            }).then(response => {
                if (response.status === 200) {
                    if (collection === 'iso') {
                        this.pins.filter(p => p.selected).forEach(pin => {
                            pin.wanted = [];
                        });
                    } else {
                        this.pins.filter(p => p.selected).forEach(pin => {
                            let found = response.data.filter(d => d.pin_id === pin.id);
                            if (found) {
                                found.forEach(pv => {
                                    let pIndex = pin.pinventory.findIndex(p => p.id === pv.id);
                                    if (collection === 'trader') {
                                        pin.pinventory[pIndex].is_trader = 0;
                                    } else {
                                        pin.pinventory.splice(pIndex, 1);
                                    }
                                });
                            }
                        });
                    }
                }
            });
        },

        // exportCollection () {
        //     // const collection = window.location.pathname.replace('/my/pin-collection/', '');
        //     const urlPartial = window.location.pathname.replace('/u/', '');
        //     const today = new Date();
        //     // const endpoint = '/my/pin-collection/export';
        //     const endpoint = '/u/' + urlPartial + '/export';
        //     axios.post(endpoint, {
        //         // collection: collection,
        //         n: this.totalSelected,
        //         pins: this.selectAll ? this.allPinIds : this.pins.filter(p => p.selected).map(p => p.id)
        //     }, {responseType: 'blob'}).then(response => {
        //         if (response.status === 200) {
        //             const data = response.data;
        //             const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        //             const link = document.createElement('a');
        //             link.href = downloadUrl;
        //             // link.setAttribute('download', 'pinandpop.com-' + collection + '-' + today.toISOString() + '.csv'); //any other extension
        //             link.setAttribute('download', 'pinandpop.com_' + urlPartial.replace('/', '_') + '_' + today.toISOString() + '.csv');
        //             document.body.appendChild(link);
        //             link.click();
        //             link.remove();
        //         }
        //     });
        // },

        copyId (id, event) {
            const el = event.target.closest('.copy-id');
            el.classList.toggle('active');
            setTimeout(() => el.classList.toggle('active'), 2000);
            navigator.clipboard.writeText(id);
        }
    },
    computed: {
        totalSelected () {
            return this.selectAll ? Math.min(this.total, this.max) : this.pins.filter(p => p.selected).length;
        },
        anySelected () {
            return !!this.pins.filter(p => p.selected).length;
        }
    },
    watch: {
        selectShown: function (newVal) {
            this.pins.forEach(p => p.selected = newVal);
            if (!newVal) {
                this.selectAll = false;
            }
        }
    }
}
</script>
